import http from './http'
import qs from 'qs'

export default {
    all(query = '') {
        return http.get(`usuarios?${query}`)
    },

    /**
     * Consulta todos los usuarios.
     * @param {String} query 
     * @returns {Promise}
     */
    paginate(query = {}) {
        return http.get(`usuarios?${qs.stringify(query)}`)
    },

    /**
     * Consulta al usuario
     * @param {int} usuario
     * @returns {Promise}
     */
    get(usuario) {
        return http.get(`usuarios/${usuario}`);
    },

    /**
     * Actualiza al usuario
     * @param {Object} payload
     * @returns {Promise} 
     */
    update(usuario, payload) {
        return http.put(`usuarios/${usuario}`, payload)
    },

    /**
     * Actualiza el estatus a un usuario
     * @param {int} usuario 
     * @returns {Promise}
     */
    estatus(usuario, estatus) {
        return http.put(`usuarios/${usuario}/estatus`, { estatus })
    },

    /**
     * Activa a un usuario
     * @param {int} usuario 
     * @returns {Promise}
     */
    activar(usuario) {
        return http.put(`usuarios/${usuario}/activar`)
    },

    /**
     * Desactiva a un usuario
     * @param {int} usuario 
     * @returns {Promise}
     */
    desactivar(usuario) {
        return http.put(`usuarios/${usuario}/desactivar`)
    },
}